import React, { PureComponent } from 'react';

class SinglePortait extends PureComponent {
  constructor(props) {
    super(props);
    this.image1Ref = React.createRef();
    this.image2Ref = React.createRef();
    this.image3Ref = React.createRef();
    this.image4Ref = React.createRef();

    this.state = {
      image1AspectRatio: '',
      image2AspectRatio: '',
      image3AspectRatio: '',
      image4AspectRatio: '',
    };
  }

  triggerSlider(e) {
    try {
      let obj = {
        type: this.props.items[0].type,
        src: this.props.items[0].src,
      };
      this.props.onShowBigImg(e, obj);
    } catch (error) {
      console.log(error);
    }
  }

  showImage(img) {
    try {
      return (
        <>
          <img
            src={img}
            alt="pic"
            ref={this.image1Ref}
            style={{ aspectRatio: this.state.image1AspectRatio }}
            onClick={(e) => this.triggerSlider()}
          />
          <img
            onClick={(e) => this.triggerSlider()}
            src={img}
            className="bgImage"
            alt="bg pic"
            ref={this.image2Ref}
            style={{ aspectRatio: this.state.image2AspectRatio }}
          />
        </>
      );
    } catch (error) {
      console.log(error);
    }
  }

  showVideo(videoThumbnailUrl) {
    try {
      return (
        <>
          <img
            src={videoThumbnailUrl}
            alt="pic"
            ref={this.image3Ref}
            style={{ aspectRatio: this.state.image3AspectRatio }}
            onClick={(e) => this.triggerSlider()}
          />
          <img
            onClick={(e) => this.triggerSlider()}
            src={videoThumbnailUrl}
            className="bgImage"
            alt="bg pic"
            ref={this.image4Ref}
            style={{ aspectRatio: this.state.image4AspectRatio }}
          />

          <img
            className="img"
            src="/img/play-light-2-pt.svg"
            alt="Play Video"
            onClick={(e) => this.triggerSlider()}
          />
        </>
      );
    } catch (error) {
      console.log(error);
    }
  }

  showItem(item) {
    try {
      return item.type === 'image'
        ? this.showImage(item.src)
        : this.showVideo(item.videoThumbnailUrl);
    } catch (error) {
      console.log(error);
    }
  }

  calculateImg1AspectRatio = () => {
    if (this.image1Ref.current) {
      const image1Src = this.image1Ref.current.src;

      const newImg = new Image();
      newImg.src = image1Src;

      newImg.onload = () => {
        const aspectRatio = newImg.width / newImg.height;
        this.setState({ image1AspectRatio: aspectRatio });
      };
    }
  };

  calculateImg2AspectRatio = () => {
    if (this.image2Ref.current) {
      const img2Src = this.image2Ref.current.src;

      const newImg = new Image();
      newImg.src = img2Src;

      newImg.onload = () => {
        const aspectRatio = newImg.width / newImg.height;
        this.setState({ image2AspectRatio: aspectRatio });
      };
    }
  };
  calculateImg3AspectRatio = () => {
    if (this.image3Ref.current) {
      const image3Src = this.image3Ref.current.src;

      const newImg = new Image();
      newImg.src = image3Src;

      newImg.onload = () => {
        const aspectRatio = newImg.width / newImg.height;
        this.setState({ image3AspectRatio: aspectRatio });
      };
    }
  };
  calculateImg4AspectRatio = () => {
    if (this.image4Ref.current) {
      const image4Src = this.image4Ref.current.src;

      const newImg = new Image();
      newImg.src = image4Src;

      newImg.onload = () => {
        const aspectRatio = newImg.width / newImg.height;
        this.setState({ image4AspectRatio: aspectRatio });
      };
    }
  };

  componentDidMount() {
    this.calculateImg1AspectRatio();
    this.calculateImg2AspectRatio();
    this.calculateImg3AspectRatio();
    this.calculateImg4AspectRatio();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.items !== this.props.items) {
      this.calculateImg1AspectRatio();
      this.calculateImg2AspectRatio();
      this.calculateImg3AspectRatio();
      this.calculateImg4AspectRatio();
    }
  }
  render() {
    return (
      <>
        {this.props.items && this.props.items.length === 1 ? (
          <div className="gallery singlePortait">
            <div className="firstTile">
              {this.showItem(this.props.items[0])}
            </div>
          </div>
        ) : (
          ''
        )}
      </>
    );
  }
}
export default React.memo(SinglePortait);
